import { debounce } from 'radash'
import { useLayoutEffect, useState } from 'react'

import { Duration } from '@blade/std-lib'

export const useWindowSize = (args?: { debounce?: Duration.Duration }) => {
  const [dimensions, setDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  })

  const delayMs = args?.debounce ? Duration.toMillis(args.debounce) : 100

  useLayoutEffect(() => {
    const handleResize = () =>
      setDimensions({ width: window.innerWidth, height: window.innerHeight })
    const debounced = debounce({ delay: delayMs }, handleResize)

    window.addEventListener('resize', debounced, { passive: true })

    return () => window.removeEventListener('resize', debounced)
  }, [delayMs])

  return dimensions
}
